@let content = currentRendering.selectors.content.asSignal();
@let isLoading = currentRendering.selectors.isRenderingLoading.asSignal();

<!-- 
Display the page content once loading is complete. While loading is in progress,
a loading overlay — managed by the parent component — will be shown.
-->
@if (content?.basic) {
  <atn-mosaic-basic-content />
} @else if (content?.scrolling) {
  <atn-mosaic-scrolling-content />
} @else if (content?.tabbed) {
  <atn-mosaic-tabbed-content />
} @else if (isLoading) {
  <atn-ds-loader type="page" />
} @else {
  <div class="atn-content-sections__empty-state">
    <atn-ds-empty-state
      description="Uh oh! We couldn't find any content for this page"
      layout="h"
      title="Uh oh! Something went wrong"
      type="error"
    >
    </atn-ds-empty-state>
  </div>
}
